export const DAILY_GOAL = 1
export const WEEKLY_GOAL = 2
export const MONTHLY_GOAL = 3


// WEBPACK FOOTER //
// ./src/constants/healthyHabits.js